const IMPERSONATION_STORAGE = 'IMPERSONATION_STORAGE';

export const isImpersonating = () => {
  if (sessionStorage) {
    const session = sessionStorage.getItem(IMPERSONATION_STORAGE);
    const sessionObject = JSON.parse(session) || {};
    return !!sessionObject?.apiKey ?? false;
  }

  return false;
};

export const getImpersonationSession = () => {
  if (sessionStorage) {
    const session = sessionStorage.getItem(IMPERSONATION_STORAGE);
    return JSON.parse(session) || {};
  }

  return {};
};

export const createImpersonationSession = ({ apiKey }) => {
  if (sessionStorage) {
    sessionStorage.setItem(IMPERSONATION_STORAGE, JSON.stringify({ apiKey }));
  }
};

export const deleteImpersonationSession = () => {
  if (sessionStorage) {
    sessionStorage.removeItem(IMPERSONATION_STORAGE);
  }
};
